import * as configSelectors from './selectors';

export const dataCaptureSelectors = configSelectors;
export * from './actions';
export { default as reducer } from './reducer';
